<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "knowledge",
      key: "id",
      url: {
        // get:'/admin/system/knowledge',
        // add:'/admin/system/knowledge',
        // edit:'/admin/system/knowledge',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "是否加密",
          name: "isEncrypt",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 2,
          onChange: this.onisEncrypt,
        },
        {
          label: "密码",
          name: "password",
          value: "",
          type: "password",
          width: "400px",
        },
        {
          label: "知识库名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "图片",
          name: "imgUrl",
          value: "",
          type: "image",
          desc: "图片尺寸最低750*420像素比例",
        },
        
        {
          label: "知识库类别",
          name: "type",
          value: "",
          width: "240px",
          type: "select",
          dropList: [],
        },
        {
          label: "知识库标签",
          name: "label",
          value: "",
          width: "240px",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "文件",
          name: "accessory",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        { label: "详情", name: "content", value: "", type: "editor" },
      ],
      forms: {},
    };
  },
  async created() {
    await this.loadlabelData();
    await this.loadtypeData();
    let query = this.$route.query;
    if (query.action == "edit"){
      await this.initData();
    }

  },
  methods: {
    async initData() {
      // 加载详情数据
      let id = this.$route.query.knowledgeId;
      let res = await $utils.api.load(`/admin/system/knowledge/${id}`, {});
      if (res) {
        if (res && res.data) {
          this.forms = res.data;
          this.forms.password = res.data.password;
          let labelid = res.data.label.split(",");
          this.forms.label = labelid.map(Number);
        }
      }
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.forms.label = this.labelid;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/knowledge`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.labelid = ass;
    },
    handleRemove(val) {
    },
    onisEncrypt(val) {
      if (val == 1) {
        this.items[this.getItemIndex("password")].type = "input";
      }
      if (val == 2) {
        this.items[this.getItemIndex("password")].type = "kong";
      }
    },
    async loadlabelData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/label/selectList", q);
      if (res) {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "label") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      }
    },
    async loadtypeData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/type/selectList", q);
      if (res) {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "type") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      }
    },
  },
};
</script>
